import React from 'react';
import Dialog from 'src/modules/shared/components/molecules/dialog';
import { User } from 'src/api/generated';
import { formatFullName } from 'src/modules/shared/utils/formatting/name.util';

interface ProfileChangeDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  pendingChange: {
    user: User;
    newProfile: string;
  } | null;
  currentUser: User | null;
  isLoading?: boolean;
}

export const ProfileChangeDialog: React.FC<ProfileChangeDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  pendingChange,
  currentUser,
  isLoading = false,
}) => {
  const isSelfDowngrade = React.useMemo(() => {
    if (!pendingChange || !currentUser) return false;

    const isDowngrade =
      (pendingChange.user.profile || 'agent') !== pendingChange.newProfile &&
      pendingChange.newProfile === 'agent';

    const isSelf = pendingChange.user.id === currentUser.id;

    return isSelf && isDowngrade;
  }, [pendingChange, currentUser]);

  const getDialogTitle = () => {
    if (!pendingChange || !currentUser) {
      // TODO: check when implementing i18n
      return 'Confirmar cambio de perfil';
    }

    return isSelfDowngrade
      ? // TODO: check when implementing i18n
        'Confirmar degradación de tu perfil'
      : 'Confirmar cambio de perfil';
  };

  const getDialogDescription = () => {
    if (!pendingChange) return '';

    const { user, newProfile } = pendingChange;
    const isSelf = currentUser && currentUser.id === user.id;

    // TODO: check when implementing i18n
    const profileLabel = newProfile === 'admin' ? 'Administrador' : 'Agente';

    // TODO: check when implementing i18n
    const userName = isSelf
      ? 'tu usuario'
      : formatFullName(user.firstName, user.lastName, user.email);

    // TODO: check when implementing i18n
    const base = `Vas a cambiar el perfil de ${userName} a "${profileLabel}".`;

    // TODO: check when implementing i18n
    const warning =
      isSelf && newProfile === 'agent'
        ? // TODO: check when implementing i18n
          ' Es posible que pierdas acceso a esta sección.'
        : '';

    return base + warning;
  };

  const getDialogVariant = () => {
    if (!pendingChange || !currentUser) return 'warning';

    return isSelfDowngrade ? 'danger' : 'warning';
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={getDialogTitle()}
      description={getDialogDescription()}
      // TODO: check when implementing i18n
      confirmLabel="Cambiar perfil"
      // TODO: check when implementing i18n
      cancelLabel="Cancelar"
      onConfirm={onConfirm}
      isLoading={isLoading}
      variant={getDialogVariant()}
    />
  );
};
